import React, { useState } from "react";
import { Bug, ChevronDown, Send, X } from "lucide-react";
import { createBugReport } from "../../api/profileService";

export default function BugReportWidget({ categorySlug = "", pseudo = "" }) {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);
  const [isSending, setIsSending] = useState(false);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
    if (status === "success") {
      setStatus(null);
      setMessage("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = message.trim();
    if (!trimmed) return;

    setIsSending(true);
    setStatus(null);
    try {
      await createBugReport({
        message: trimmed,
        category_slug: categorySlug,
        pseudo,
      });
      setStatus("success");
      setMessage("");
    } catch {
      setStatus("error");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {isOpen && (
        <div className="w-80 overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-2xl">
          <div className="flex items-center justify-between border-b border-slate-100 bg-slate-50 px-4 py-3">
            <div className="flex items-center gap-2">
              <Bug className="h-4 w-4 text-rose-500" />
              <span className="text-sm font-bold text-slate-900">
                Signaler un bug
              </span>
            </div>
            <button
              type="button"
              onClick={handleToggle}
              className="rounded-full p-1 text-slate-400 transition hover:bg-slate-200 hover:text-slate-700"
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          <div className="p-4">
            {status === "success" ? (
              <div className="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-4 text-center">
                <p className="text-sm font-semibold text-emerald-700">
                  Merci ! Ton signalement a ete envoye.
                </p>
                <button
                  type="button"
                  onClick={() => {
                    setStatus(null);
                    setMessage("");
                  }}
                  className="mt-3 text-xs font-semibold text-emerald-600 underline underline-offset-2"
                >
                  Signaler un autre bug
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-3">
                <p className="text-xs text-slate-500">
                  Decris le probleme rencontre. Notre equipe le traitera rapidement.
                </p>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Ex: l'image ne se charge pas, le chrono est bloque..."
                  rows={4}
                  maxLength={2000}
                  className="w-full resize-none rounded-2xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
                />
                {status === "error" && (
                  <p className="text-xs font-semibold text-rose-600">
                    Erreur lors de l'envoi. Verifie ta connexion.
                  </p>
                )}
                <button
                  type="submit"
                  disabled={isSending || !message.trim()}
                  className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-300"
                >
                  <Send className="h-4 w-4" />
                  {isSending ? "Envoi..." : "Envoyer"}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={handleToggle}
        title="Signaler un bug"
        className={`flex h-13 w-13 items-center justify-center rounded-full shadow-lg transition ${
          isOpen
            ? "bg-slate-800 text-white"
            : "bg-rose-500 text-white hover:bg-rose-600"
        }`}
        style={{ width: "52px", height: "52px" }}
      >
        {isOpen ? (
          <ChevronDown className="h-5 w-5" />
        ) : (
          <Bug className="h-5 w-5" />
        )}
      </button>
    </div>
  );
}
